import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import './style.scss';
import { useEffect, useState } from 'react';
import GamePageLayout from '../../../layout/GamePageLayout';
import Footer from '../../../layout/Footer';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectGame, selectRallyInfo, setCurrentTaskId } from '../../../store/slices/rallyGame';
import { generateTaskRoutePath } from '../../../helpers';
import { APP_ROUTES } from '../../../app.config.vars/routes';
import { useAppDispatch } from '../../../store';
import GameStatusView from '../../../components/GameStatusView';
import GameResultControls from '../../../modules/GameControls/gameResultControls';
import useFetchRally from '../../../hooks/fetchData/fetchRally';
import useFetchGameState from '../../../hooks/fetchData/fetchGameState';
import { GAME_END_TIME, GAME_START_TIME } from '../../../app.config.vars/stored';
import Loader from '../../../ui/Loader';
const GameResultPage = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const game = useSelector(selectGame);
    const rally = useSelector(selectRallyInfo);
    const [gameTimeDurationMs, setGameTimeDurationMs] = useState();
    useFetchRally(id);
    useFetchGameState();
    useEffect(() => {
        dispatch(setCurrentTaskId(null));
        const gameStartTime = new Date(localStorage.getItem(GAME_START_TIME));
        const gameEndTime = new Date(localStorage.getItem(GAME_END_TIME));
        setGameTimeDurationMs(gameEndTime.getTime() - gameStartTime.getTime());
    }, []);
    const handleNavButtonClick = async (taskNumber) => {
        navigate(generateTaskRoutePath(APP_ROUTES.rallyGamePlay, id, taskNumber));
    };
    return (_jsxs(_Fragment, { children: [_jsx("div", { className: 'page-content-wrapper rally-game-page', children: rally ? (_jsx(GamePageLayout, { id: id, rally: rally, showGameResult: true, onNavButtonClick: handleNavButtonClick, controls: _jsx(GameResultControls, { points: game.totalPoints, minutes: Math.round(gameTimeDurationMs / 60000), rallyTitle: rally.publicTitle }), children: _jsx(GameStatusView, { points: game.totalPoints, awardBadge: rally.badgeBase64, gameDurationMS: gameTimeDurationMs }) })) : (_jsx(Loader, {})) }), _jsx(Footer, { layout: "gameplay" })] }));
};
export default GameResultPage;
